// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCardMain_card__C4LkB","title":"NewsCardMain_title__s75wG","promo":"NewsCardMain_promo__sbCvp","favorite":"NewsCardMain_favorite__IcM9s"};